// roster.ts — award hub link 1. The project roster (awarded subs on a
// project) + COI/W-9 status + clearance. See workers/core-os/src/routes/
// project_roster.ts. COI/W-9 request actions reuse the org-level
// contractorsApi.requestCoi / requestW9.

import { request } from './request'

export interface RosterMember {
  id: string
  contractor_id: string
  trade: string | null
  award_id: string | null
  start_clearance_status: string
  start_clearance_reason: string | null
  cleared_to_start_at: string | null
  created_at: string
  contractor_display_name: string
  primary_contact_email: string | null
  awarded_amount_cents: number | null
  coi_count: number
  coi_latest_expiration: string | null
  w9_status: string | null
  assigned_task_count: number
  coi_ok: boolean
  w9_ok: boolean
  ready_to_clear: boolean
}

export interface ProjectRosterResponse {
  ok: true
  members: RosterMember[]
  count: number
  summary: { cleared: number; ready_to_clear: number }
}

export const rosterApi = {
  get: (projectId: string) =>
    request<ProjectRosterResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/roster`,
    ),
  setClearance: (
    projectId: string,
    projectContractorId: string,
    status: 'not_evaluated' | 'blocked' | 'cleared' | 'revoked',
    reason?: string,
  ) =>
    request<{ ok: true; id: string; start_clearance_status: string }>(
      `/api/projects/${encodeURIComponent(projectId)}/roster/${encodeURIComponent(
        projectContractorId,
      )}`,
      { method: 'PATCH', body: JSON.stringify({ start_clearance_status: status, reason }) },
    ),
}
